import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Line icons traced from the Template Library design. Same convention as
 * `TemplatesIcons`: stroked, `currentColor`, sized by the caller's `sx`.
 */

const stroke = (width: number) => ({
  fill: "none",
  stroke: "currentColor",
  strokeWidth: width,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
});

/** Stacked layers — marks a kit. */
export const KitGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...stroke(2.2)} d="M12 2 2 7l10 5 10-5-10-5z" />
    <path {...stroke(2.2)} d="M2 17l10 5 10-5M2 12l10 5 10-5" />
  </SvgIcon>
);

/** Open book — "FROM LIBRARY". */
export const LibraryGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      {...stroke(2.2)}
      d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z"
    />
    <path {...stroke(2.2)} d="M4 19.5A2.5 2.5 0 0 0 6.5 22H20v-5" />
  </SvgIcon>
);

export const ArrowRightGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...stroke(2.2)} d="M5 12h14M13 6l6 6-6 6" />
  </SvgIcon>
);

/** Chevron down — the Sort dropdown. */
export const ChevronDownGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...stroke(2.2)} d="M6 9l6 6 6-6" />
  </SvgIcon>
);

/** Pen — "Use template". */
export const PenGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...stroke(2)} d="M12 20h9" />
    <path {...stroke(2)} d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </SvgIcon>
);

/** Tray download — "Import to My templates". */
export const ImportGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...stroke(2)} d="M12 4v11M7.5 10.5 12 15l4.5-4.5" />
    <path {...stroke(2)} d="M4 20h16" />
  </SvgIcon>
);

export const CheckGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...stroke(2.6)} d="M4 12.5l5 5L20 6.5" />
  </SvgIcon>
);

/** PDF file mark in the preview's file bar. */
export const PdfFileGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      {...stroke(1.9)}
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
    />
    <path {...stroke(1.9)} d="M14 2v6h6" />
  </SvgIcon>
);
